export const Config = {
  //PROUCTモード:true DEVモード:false
  isProduct: true,

  //電話番号
  ACCEPTANCE_PHONE_NUMBER: "052-485-5008",

  DEV: {
    PRODUCT: false,
    API_URL: "https://test-api-hanaito.bvs.tokyo",
    SCHEME: "hanaito",
  },
  PRODUCT: {
    PRODUCT: true,
    API_URL: "https://api-hanaito.bvs.tokyo",
    SCHEME: "hanaito",
  },
  getSet: () => {
    if (Config.isProduct) {
      return Config.PRODUCT;
    } else {
      return Config.DEV;
    }
  },
};



// WEBPACK FOOTER //
// ./src/config/config.ts